import React from 'react';
import { NavDropdown } from 'react-bootstrap-v5'
import { InertiaLink } from '@inertiajs/inertia-react';
import Footer from '@/Components/Footer';

export default function Authenticated({ app, auth, children }) {
    const navItems = [{ route: 'home', name: '首頁' }]
    // if (auth.abilities.includes('manage-user')) {
    //     navItems.push({ route: 'users', name: '管理' })
    // }

    const toggleOverlay = () => document.body.classList.toggle("overlay")

    return (
        <div id="wrapper">
            <header className="main-header">
                <div className="container">
                    <div className="header-holder d-flex align-items-center ">
                        <InertiaLink className="navbar-brand" href="/">
                            <img src={app.logo} alt={app.name} />
                        </InertiaLink>
                        <button className="menu-toggler" aria-label="Toggle navigation" onClick={toggleOverlay}>
                            <span className="toggler-icon"></span>
                            <span className="toggler-icon"></span>
                            <span className="toggler-icon"></span>
                        </button>
                        <div className="main-nav-holder">
                            <ul className="navbar-nav scroll-nav d-flex list-unstyled">
                                {navItems.map(item => (
                                    <li key={item.route} className="nav-item">
                                        <InertiaLink href={route(item.route)} className={'nav-link ' + (route().current(item.route) ? 'active' : '')}>
                                            {item.name}
                                        </InertiaLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* <ul className="btn-list d-flex list-unstyled">
                            <NavDropdown title={auth.user.displayName || auth.user.email} id="basic-nav-dropdown">
                                <InertiaLink className="dropdown-item" href={route('logout')} method="post" as="button">
                                    登出
                                </InertiaLink>
                            </NavDropdown>
                        </ul> */}
                        <div className="secondary-nav">
                            <div className="logo-alt d-flex justify-content-center d-lg-none">
                                <InertiaLink className="navbar-brand" href="/" onClick={toggleOverlay}>
                                    <img src={app.logo} alt={app.name} />
                                </InertiaLink>
                            </div>
                            <div className="collapse-navbar" id="navMenu">
                                <ul className="navbar-nav d-flex">
                                    {navItems.map(item => (
                                        <li key={item.route} className="nav-item">
                                            <InertiaLink href={route(item.route)} className={'nav-link ' + (route().current(item.route) ? 'active' : '')} onClick={toggleOverlay}>
                                                {item.name}
                                            </InertiaLink>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <button className="close menu-toggler" aria-label="Toggle navigation" onClick={toggleOverlay}>
                                <span className="toggler-icon"></span>
                                <span className="toggler-icon"></span>
                            </button>
                            <div id="overlay-holder" onClick={toggleOverlay}></div>
                        </div>
                    </div>
                </div>
            </header>

            <main className="main">
                <div id="topAnchor"></div>
                {children}
            </main>

            <Footer />
        </div>
    );
}
